var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreshworksVectorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4D4D4D;}\n\t.st1{fill:#9B65C3;}\n\t.st2{fill:#BE63C5;}\n\t.st3{fill:#BF63C6;}\n\t.st4{fill:#3278B1;}\n\t.st5{fill:#3278B2;}\n\t.st6{fill:#45A4EC;}\n\t.st7{fill:#19BB7D;}\n\t.st8{fill:#08C7FB;}\n\t.st9{fill:#59F2F6;}\n\t.st10{fill:#FFA700;}\n\t.st11{fill:#DA3757;}\n\t.st12{fill:#D33C4E;}\n\t.st13{fill:#EE5A24;}\n\t.st14{fill:#8BDF55;}\n\t.st15{fill:#25C16F;}\n\t.st16{fill:#FFBB00;}\n\t.st17{fill:#FFA800;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.8,264.7c-15.1,0-20.4,10.5-20.4,20.3v6h-3.2c-2.3,0-4.1,1.8-4.1,4.1c0,2.3,1.8,4.1,4.1,4.1h3.2v41.4 c0,2.4,1.9,4.4,4.4,4.4c2.4,0,4.4-1.9,4.4-4.4v-41.4h9.7c2.3,0,4.1-1.8,4.1-4.1c0-2.3-1.8-4.1-4.1-4.1h-9.7v-6c0-5.5,2-12,11.7-12 c2.3,0,4.1-1.8,4.1-4.1C171.9,266.5,170.1,264.7,167.8,264.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.8,289.6c-6.5,0-12,2.7-15.1,7.1v-2.3c0-2.4-1.9-4.4-4.4-4.4c-2.4,0-4.4,1.9-4.4,4.4v46.2 c0,2.4,1.9,4.4,4.4,4.4c2.4,0,4.4-1.9,4.4-4.4v-25.5c0-10.7,5.7-17.1,15.1-17.1c2.3,0,4.2-1.9,4.2-4.2 C206.1,291.5,204.2,289.6,201.8,289.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.3,312.3c0-2.5-0.4-9-4.2-14.4c-3.9-5.6-10-8.5-18.3-8.5c-15.4,0-24.2,10.2-24.2,28 c0,18.4,8.8,28.2,25.3,28.2c11.1,0,17.2-5.5,18.3-6.6c0.7-0.7,1.5-1.6,1.5-3.1c0-2.2-1.8-4-4-4c-1.1,0-1.8,0.3-2.5,0.8 c-3.2,2.4-6.9,4.8-13.2,4.8c-9.9,0-16.2-6.5-16.5-17.1H250C255.3,320.3,255.3,315.5,255.3,312.3 M232.8,297.4 c9,0,13.7,5.1,13.9,15.1h-29.1C218.4,302.8,223.8,297.4,232.8,297.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.7,313c-6.5-2.2-12.1-4.2-12.1-9c0-5.3,5.9-6.1,9.4-6.1c6.3,0,9.4,2.2,11.9,4.6c0.8,0.8,1.8,1.2,2.9,1.2 c2.2,0,4-1.8,4-4c0-1.2-0.5-2-0.9-2.6c-3.7-4.9-10-7.6-17.9-7.6c-11.2,0-18.1,5.6-18.1,14.5c0,10.9,9.6,14.2,18,17 c6.4,2.2,11.9,4,11.9,8.7c0,6.4-7.1,7.4-11.4,7.4c-5.8,0-10.3-1.8-14-5.4c-1.1-1.1-2.3-1.3-3-1.3c-2.2,0-4,1.8-4,4 c0,0.9,0.3,1.6,1,2.6c3.3,4.2,10.8,8.5,20,8.5c12.6,0,20.1-5.9,20.1-15.7C302.5,319.2,293.1,315.9,284.7,313"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.6,289.4c-6,0-11.4,2.4-14.4,6.2V266c0-2.4-1.9-4.4-4.4-4.4c-2.4,0-4.4,1.9-4.4,4.4v74.7 c0,2.4,1.9,4.4,4.4,4.4c2.4,0,4.4-1.9,4.4-4.4v-28.1c0-10.1,4.9-15.2,14.4-15.2c9.2,0,13,4.2,13,14.4v28.9c0,2.4,1.9,4.4,4.4,4.4 c2.4,0,4.4-1.9,4.4-4.4v-30.4C358.2,296.4,350.9,289.4,336.6,289.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.1,290.1c-1.9,0-3.4,1.1-4.1,2.9l-12.5,35.6L404.3,293c-0.4-1.4-1.9-2.9-4.1-2.9s-3.7,1.5-4.1,2.9 l-10.2,35.5l-12.5-35.6c-0.7-1.8-2.2-2.8-4.1-2.8c-2.4,0-4.4,1.9-4.4,4.4c0,0.6,0.1,1.2,0.4,1.8l16.7,45.9c0.7,1.8,2.2,2.8,4.1,2.8 c2,0,3.7-1.3,4.2-3.1l9.8-33.7l9.8,33.7c0.5,1.8,2.3,3.1,4.2,3.1c1.9,0,3.4-1.1,4.1-2.9l16.7-45.9c0.3-0.6,0.4-1.3,0.4-1.9 C435.4,292,433.5,290.1,431.1,290.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462.9,289.4c-15.9,0-24.6,10-24.6,28c0,18.2,8.7,28.2,24.6,28.2c15.9,0,24.6-10,24.6-28.2 C487.5,299.3,478.7,289.4,462.9,289.4 M462.9,337.6c-10.6,0-15.8-6.6-15.8-20.1c0-13.3,5.3-20,15.8-20c10.5,0,15.8,6.7,15.8,20 C478.7,331,473.5,337.6,462.9,337.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.3,289.6c-6.5,0-12,2.7-15.1,7.1v-2.3c0-2.4-1.9-4.4-4.4-4.4c-2.4,0-4.4,1.9-4.4,4.4v46.2 c0,2.4,1.9,4.4,4.4,4.4c2.4,0,4.4-1.9,4.4-4.4v-25.5c0-10.7,5.7-17.1,15.1-17.1c2.3,0,4.2-1.9,4.2-4.2 C525.5,291.5,523.6,289.6,521.3,289.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M554.5,312.4l18.1-14.5c1.5-1.2,1.7-2.7,1.7-3.5c0-2.4-1.9-4.4-4.4-4.4c-0.7,0-1.9,0.1-3,1.1l-25.7,21V266 c0-2.4-1.9-4.4-4.4-4.4c-2.4,0-4.4,1.9-4.4,4.4v74.7c0,2.4,1.9,4.4,4.4,4.4c2.4,0,4.4-1.9,4.4-4.4v-18l6.1-4.9l19.7,25.3l0,0 c1.1,1.3,2.3,2,3.7,2c2.4,0,4.4-1.9,4.4-4.4c0-0.7-0.1-1.7-0.9-2.7L554.5,312.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M603.8,313c-6.5-2.2-12.1-4.2-12.1-9c0-5.3,5.9-6.1,9.4-6.1c6.3,0,9.4,2.2,11.9,4.6c0.8,0.8,1.8,1.2,2.9,1.2 c2.2,0,4-1.8,4-4c0-1.3-0.7-2.2-0.9-2.6c-3.7-4.9-10-7.6-17.9-7.6c-11.2,0-18.1,5.6-18.1,14.5c0,10.9,9.6,14.2,18,17 c6.4,2.2,11.9,4,11.9,8.7c0,6.4-7.1,7.4-11.4,7.4c-5.8,0-10.3-1.8-14-5.4c-1.1-1.1-2.2-1.3-3-1.3c-2.2,0-4,1.8-4,4 c0,0.9,0.3,1.6,1,2.6c3.3,4.2,10.8,8.5,20,8.5c12.6,0,20.1-5.9,20.1-15.7C621.6,319.2,612.2,315.9,603.8,313"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.2,338.2c1.7,11.1,6.9,21.1,14.4,28.6l17.5-17.5c0-17.7,9.2-34.9,25.6-44.4L22.2,338.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.1,349.3c-8.7,0-17.5-2.2-25.6-6.9c-2.2-1.3-4.3-2.7-6.3-4.3c1.7,11.1,6.9,21.1,14.4,28.6L54.1,349.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.1,349.3L54.1,349.3l-17.5,17.5c7.6,7.6,17.5,12.8,28.6,14.4l33.2-57.5C89,340.1,71.8,349.3,54.1,349.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61,375c-4.7-8.1-6.9-16.9-6.9-25.6l-17.5,17.5c7.6,7.6,17.5,12.8,28.6,14.4C63.7,379.3,62.3,377.2,61,375"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M119.3,282.1L79.8,305c-16.4,9.5-35.9,8.8-51.2,0c-4.4,7.5-6.9,16.3-6.9,25.6c0,2.6,0.2,5.1,0.6,7.6 c2,1.6,4.1,3,6.3,4.3c8.1,4.7,16.9,6.9,25.6,6.9l66.2-66.2C120,282.8,119.7,282.4,119.3,282.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M28.5,342.5c8.1,4.7,16.9,6.9,25.6,6.9c0-17.7,9.2-34.9,25.6-44.4l-57.6,33.2 C24.2,339.7,26.3,341.2,28.5,342.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M28.5,305c-4.4,7.5-6.9,16.3-6.9,25.6c0,2.6,0.2,5.1,0.6,7.6L79.8,305C63.3,314.4,43.8,313.8,28.5,305"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M120.4,283.1c-0.3-0.3-0.7-0.7-1.1-1c-0.5-0.4-1-0.8-1.6-1.1c-1.9-1.1-4.1-1.7-6.4-1.7H72.9 c-19,0-35.5,10.3-44.4,25.6c15.3,8.8,34.8,9.5,51.2,0c-16.4,9.5-25.6,26.7-25.6,44.4c17.7,0,34.9-9.2,44.4-25.6l22.8-39.5 C121,283.8,120.7,283.4,120.4,283.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M79.8,305l39.5-22.8c-0.5-0.4-1-0.8-1.6-1.1L28.5,305C43.8,313.8,63.3,314.4,79.8,305"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M111.3,279.3H72.9c-19,0-35.5,10.3-44.4,25.6l89.2-23.9C115.8,280,113.7,279.3,111.3,279.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M54.1,349.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M98.5,323.7l22.8-39.5c-0.3-0.4-0.6-0.7-1-1.1l-66.2,66.2c0,8.7,2.2,17.5,6.9,25.6c1.3,2.2,2.7,4.3,4.3,6.3 c2.5,0.4,5,0.6,7.6,0.6c9.3,0,18.1-2.5,25.6-6.9C89.7,359.6,89,340.1,98.5,323.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M54.1,349.3L54.1,349.3c0,8.7,2.2,17.5,6.9,25.6c1.3,2.2,2.7,4.3,4.3,6.3l33.2-57.5 C89,340.1,71.8,349.3,54.1,349.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.5,323.7l-33.2,57.6c2.5,0.4,5,0.6,7.6,0.6c9.3,0,18.1-2.5,25.6-6.9C89.7,359.6,89,340.1,98.5,323.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M122.4,285.8c-0.3-0.6-0.7-1.1-1.1-1.6c-0.3-0.4-0.6-0.7-1-1.1c-0.3-0.3-0.7-0.7-1.1-1L79.8,305 c-16.4,9.5-25.6,26.7-25.6,44.4c17.7,0,34.9-9.2,44.4-25.6c-9.5,16.4-8.8,35.9,0,51.2c15.3-8.9,25.6-25.4,25.6-44.4v-38.4 C124.1,289.8,123.5,287.6,122.4,285.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M119.3,282.1L79.8,305c-16.4,9.5-25.6,26.7-25.6,44.4l66.2-66.2C120,282.8,119.7,282.4,119.3,282.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M54.1,349.3c17.7,0,34.9-9.2,44.4-25.6l22.8-39.5c-0.3-0.4-0.6-0.7-1-1.1L54.1,349.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M121.3,284.2l-22.8,39.5c-9.5,16.4-8.8,35.9,0,51.2l23.9-89.2C122.1,285.2,121.7,284.7,121.3,284.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M98.5,375c15.3-8.9,25.6-25.4,25.6-44.4v-38.4c0-2.3-0.6-4.5-1.7-6.4L98.5,375z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshworksVectorLogo);
export default __webpack_public_path__ + "static/media/Freshworks-vector-logo.1cce466db46823bc5511d2419b61abd6.svg";
export { ForwardRef as ReactComponent };